import styled from 'styled-components';

export const Container = styled.div`
  align-self: stretch;
  margin: 0 16px;
  padding: 14px 16px;
  border-radius: 12px;
  background-color: ${({ theme }) => theme.colors.semantic.status.attention};
`;

export const Text = styled.p`
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.semantic.text.primary};
`;

export const Title = styled.strong`
  font-weight: 600;
`;
